/** Client-safe ChatHelp handshake. The screen owns the question. */

export const CHAT_HELP_EVENT = 's2r:chat-help'

export type ChatHelpDetail = {
  question: string
}

export function readChatHelpDetail(event: Event): ChatHelpDetail | null {
  if (!(event instanceof CustomEvent)) return null
  const detail: unknown = event.detail
  if (!detail || typeof detail !== 'object') return null
  const question = (detail as Record<string, unknown>).question
  if (typeof question !== 'string') return null
  const trimmed = question.trim()
  if (!trimmed) return null
  return { question: trimmed }
}
